import { Controller } from "@hotwired/stimulus"
import { parseMoney, formatMoney } from "../lib/money"

// Formats a typed amount when the field loses focus without moving the caret
// while the user is entering the integer and centavos.
export default class extends Controller {
  input() {
    this.element.setCustomValidity("")
  }

  blur() {
    if (!this.element.value.trim()) return

    const amount = parseMoney(this.element.value)
    if (amount === null) {
      this.element.setCustomValidity("Informe um valor válido, como 39,90.")
      return
    }

    this.element.value = formatMoney(amount)
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
